
<mat-card class="slidecontent">
    <div class="headcontent">
        <div class="pophead">
            <h3>Edit Role</h3>
        
            <mat-icon (click)="close(closePannel)" class="close">close</mat-icon>
        </div>
        </div>
        
        <div class="dialog_content">
        
            <form [formGroup]="updateRoleDetailform">
        
                
                    <mat-form-field class="mb-5">
                        <mat-label>Role Name</mat-label>
                        <input matInput maxlength="30" placeholder="Role Name" formControlName="roleName"
                            [(ngModel)]="updateRoleDetail.roleName">
                        <mat-error>
                            This field is required
                        </mat-error>
                    </mat-form-field>
                
                    <mat-form-field class="mb-5">
                        <mat-label>Role Description</mat-label>
                        <input matInput maxlength="100" placeholder="Role Description" formControlName="roleDescription"
                            [(ngModel)]="updateRoleDetail.description">
                        <mat-error>
                            This field is required
                        </mat-error>
                    </mat-form-field>
                
        
                
                <!-- <div class="selectedPermission">
                    
                    <div class="selList">
                        <ng-container *ngFor="let name of selectedItems"  >
                            <span>{{name.item_text}}</span>                       
                        </ng-container>
                    </div>                    
                </div> -->
    
             
                    <!-- <mat-list-item class="primary-imenu-item fullw" role="listitem">
                        <mat-form-field appearance="legacy" class="select-form form-element" fxFlex>
                            <mat-select placeholder="Permissions" name="permissions" class="filter-select" formControlName="selectedPermission"
                                [(ngModel)]="updateRoleDetail.rolePermissions"  multiple>
                                <mat-option *ngFor="let per of permList" [value]="per.permissionID">
                                    {{per.permissionName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-list-item> -->
    
         
               <div class="selectedPermission mb-5">
                <h4>Selected Permissions </h4>
               
         <div class="multiDrop ">
            
            <ng-multiselect-dropdown
            [placeholder]="'Select Permissions'"
            [settings]="dropdownSettings"
            [data]="dropdownList"
            [(ngModel)]="selectedItems"
            formControlName="selectedPermission"                
            name="selectedPermission"
             >
            </ng-multiselect-dropdown>
            
           </div>
        </div>
         <div class="form-element">
                    <mat-checkbox formControlName="isActive" color="primary" [(ngModel)]="updateRoleDetail.isActive">Active</mat-checkbox>
                </div> 
            </form>
        </div>
    
    
    
    
    <div class="actionBtn">
    
        <button mat-flat-button class="cancel" (click)="close(closePannel)">Cancel</button>
        <button mat-flat-button class="calltoaction" type="submit" [disabled]="!updateRoleDetailform.valid"
        (click)="updateRole()" color="primary">Update</button>
    </div>
</mat-card>

<div class="overlay" (click)="close(closePannel)" ></div>
  